import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var STATUS_ASSIGNMENT = {
  ACTIVE: '3',
  PUBLISHED_SCORE: '5',
  UPCOMING: '6',
  ONGOING: '7',
  ENDED: '8',
  PASS: '10',
  FAIL: '11'
};

var handleColorType = function handleColorType(statusType) {
  switch (statusType) {
    case STATUS_ASSIGNMENT.ONGOING:
      return 'color: #1A5AFF; background: #E6F2FF; border: 1px solid #1A5AFF;';

    case STATUS_ASSIGNMENT.ACTIVE:
      return 'color: #52c41a; background: #eaffe6; border: 1px solid #52c41a;';

    case STATUS_ASSIGNMENT.UPCOMING:
      return 'color: #FA8C16; background: #FFF7E6;border: 1px solid #FFD591;';

    case STATUS_ASSIGNMENT.PUBLISHED_SCORE:
      return 'color: #3A8814; background: #E8FCD5;border: 1px solid #52C41A;';

    case STATUS_ASSIGNMENT.PASS:
      return 'color: #3A8814; background: #E8FCD5; border: 1px solid #52C41A;';

    case STATUS_ASSIGNMENT.FAIL:
      return 'color: #CF1322; background: #FFF1F0;border: 1px solid #F5222D;';

    default:
      return 'color: #8C8C8C; background: #F0F0F0;border: 1px solid #8C8C8C;';
  }
};

var StyledDefaultStatus = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 1px 8px;\n  ", ";\n  width: fit-content;\n  border-radius: 2px;\n  display: block;\n  text-align: center;\n  font-size: 12px;\n"])), function (_ref) {
  var statusType = _ref.statusType;
  return handleColorType(statusType);
});
export var DefaultStatus = function DefaultStatus(_ref2) {
  var statusType = _ref2.statusType,
      text = _ref2.text,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '100px' : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? '22px' : _ref2$height,
      style = _ref2.style,
      className = _ref2.className;
  return /*#__PURE__*/_jsx(StyledDefaultStatus, {
    statusType: statusType,
    width: width,
    height: height,
    style: style,
    className: className,
    children: text
  });
};